import { render, staticRenderFns } from "./SendReferral.vue?vue&type=template&id=4387d35f&"
import script from "./SendReferral.vue?vue&type=script&lang=js&"
export * from "./SendReferral.vue?vue&type=script&lang=js&"
import style0 from "./SendReferral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports